import React, { useEffect, useState } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import config from "../../../../config";

const MapContainer = ({ google, startLocation, endLocation }) => {
  return (
    <Map
      google={google}
      zoom={10}
      center={{ lat: startLocation.lat, lng: startLocation.lng }}
      initialCenter={{ lat: startLocation.lat, lng: startLocation.lng }}
    >
      <Marker
        position={{ lat: startLocation.lat, lng: startLocation.lng }}
        label="Pick-up"
      />
      <Marker
        position={{ lat: endLocation.lat, lng: endLocation.lng }}
        label="Drop-off"
      />
    </Map>
  );
};

export default GoogleApiWrapper({
  apiKey: config.googleMapKey,
})(MapContainer);
